<div class="content">
  <h1 class="title">Welcome to the Avrae UI!</h1>
  <p>This page lets you create commands for Avrae using buttons.</p>
  <ol>
    <li>Click a module.</li>
    <li>Click a command.</li>
    <li>Click some arguments.</li>
    <li>Fill in the input boxes.</li>
    <li>Click copy.</li>
    <li>Paste to discord.</li>
  </ol>

  <h2>Legend</h2>

  <div class="flex">
    <div class="icon">
      <svg
        class="copy-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 699.428 699.428"
      >
        <path
          d="M502.714,0.678C500.004,0.678,240.428,0,240.428,0C194.178,0,153,42.425,153,87.429l-25.267,0.59c-46.228,0-84.019,41.834-84.019,86.838V612c0,45.004,41.179,87.428,87.429,87.428H459c46.249,0,87.428-42.424,87.428-87.428h21.857c46.25,0,87.429-42.424,87.429-87.428v-349.19L502.714,0.678z M459,655.715H131.143c-22.95,0-43.714-21.441-43.714-43.715V174.857c0-32.523,26.753-43.714,65.571-43.714v393.429C153,569.576,194.178,612,240.428,612c0,0,236.975-0.24,262.482-0.24C502.91,638.295,485.513,655.715,459,655.715z M502.714,459.24H306c-12.065,0-21.857-9.77-21.857-21.836c0-12.064,9.792-21.834,21.857-21.834h196.714c12.065,0,21.857,9.77,21.857,21.834C524.571,449.471,514.779,459.24,502.714,459.24z M502.714,350.064H306c-12.065,0-21.857-9.771-21.857-21.835c0-12.065,9.792-21.835,21.857-21.835h196.714c12.065,0,21.857,9.77,21.857,21.835C524.571,340.272,514.779,350.064,502.714,350.064z M546.428,174.857c-23.277,0-43.714-21.004-43.714-43.714c0,0,0-44.283,0-86.751v-0.044L612,174.857H546.428z"
        />
      </svg>
    </div>
    <p class="half-margin">Copy to Clipboard</p>
  </div>

  <div class="flex">
    <div class="icon">
      <svg
        class="settings-icon"
        viewBox="0 0 128 128"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M119.78,73.778l-4.563-4.901c0.005-0.043,0.004-0.085-0.001-0.149c0.098-1.093,0.163-2.194,0.206-3.296  c0.01-0.318-0.003-0.658,0.003-0.976c0.009-0.845-0.003-1.662-0.041-2.478c-0.016-0.357-0.035-0.689-0.058-1.044  c-0.019-0.545-0.047-1.083-0.088-1.652l4.576-4.867c2.183-2.325,6.146-5.412,4.933-8.351l-5.01-12.157  c-1.213-2.942-6.194-2.325-9.379-2.436l-6.681-0.241c-0.505-0.604-1.049-1.178-1.572-1.761c-0.02-0.022-0.044-0.056-0.069-0.087  c-0.186-0.195-0.343-0.407-0.531-0.599c-0.283-0.308-0.609-0.602-0.901-0.902c-0.423-0.426-0.844-0.859-1.278-1.271  c-0.712-0.685-1.463-1.331-2.203-1.972c-0.03-0.031-0.078-0.057-0.104-0.078c-0.04-0.039-0.076-0.083-0.116-0.123l-0.216-6.693  c-0.098-3.169,0.525-8.159-2.397-9.375L82.129,3.308c-2.926-1.218-6.034,2.747-8.352,4.91L68.88,12.79  c-1.098-0.11-2.188-0.167-3.279-0.209c-0.305-0.012-0.612-0.006-0.938-0.004c-0.703-0.006-1.412-0.027-2.135,0.001  c-0.913,0.029-1.826,0.086-2.736,0.165c-0.117,0.006-0.234,0.006-0.326,0.014c-0.065,0.013-0.114,0.003-0.18,0.016l-4.871-4.586  c-2.321-2.171-5.412-6.146-8.351-4.935L33.907,8.262c-2.942,1.212-2.32,6.205-2.437,9.381l-0.237,6.691  c-0.073,0.055-0.146,0.131-0.214,0.198c-0.799,0.666-1.583,1.354-2.345,2.07c-0.281,0.276-0.552,0.554-0.827,0.833  c-0.541,0.527-1.084,1.071-1.603,1.63c-0.266,0.29-0.511,0.584-0.77,0.88c-0.352,0.382-0.696,0.759-1.033,1.162l-6.697,0.205  c-3.169,0.099-8.159-0.524-9.375,2.399l-5.063,12.16c-1.217,2.927,2.742,6.024,4.905,8.342l4.573,4.898  c-0.074,0.758-0.107,1.512-0.149,2.279c0.001,0.071-0.012,0.146-0.01,0.217c-0.062,1.3-0.093,2.598-0.048,3.892  c0.021,0.568,0.063,1.126,0.099,1.693c0.033,0.458,0.043,0.924,0.086,1.381c-0.003,0.05,0.001,0.096,0.005,0.13l-4.582,4.884  c-2.172,2.317-6.15,5.399-4.939,8.337l5.01,12.157c1.213,2.944,6.209,2.331,9.385,2.447l6.687,0.227  c0.045,0.066,0.099,0.105,0.147,0.173c0.678,0.814,1.39,1.609,2.132,2.409c0.261,0.281,0.537,0.522,0.802,0.798  c0.545,0.553,1.094,1.1,1.662,1.633c0.279,0.242,0.574,0.495,0.856,0.756c0.395,0.349,0.779,0.705,1.175,1.023l0.204,6.696  c0.1,3.169-0.52,8.171,2.404,9.388l12.16,5.062c2.928,1.219,6.023-2.743,8.341-4.906l4.902-4.562  c0.054,0.001,0.106-0.006,0.16-0.005c0.631,0.07,1.257,0.094,1.883,0.126c0.188,0.016,0.37,0.017,0.548,0.036  c0.294,0.009,0.576,0.032,0.86,0.042c0.336,0.007,0.671-0.003,1.007-0.002c0.817,0.019,1.635,0.002,2.445-0.035  c0.353-0.012,0.714-0.039,1.063-0.059c0.551-0.024,1.082-0.051,1.624-0.083l4.879,4.57c2.324,2.183,5.399,6.151,8.337,4.938  l12.158-5.01c2.943-1.214,2.335-6.199,2.447-9.385l0.23-6.676c0.573-0.478,1.125-0.976,1.658-1.462  c0.075-0.087,0.161-0.148,0.243-0.217c0.186-0.176,0.385-0.324,0.545-0.493c0.324-0.287,0.603-0.604,0.898-0.89  c0.422-0.427,0.87-0.854,1.299-1.301c0.623-0.669,1.25-1.369,1.856-2.098c0.069-0.065,0.123-0.12,0.182-0.205  c0.051-0.045,0.082-0.075,0.111-0.11l6.691-0.215c3.169-0.099,8.171,0.521,9.388-2.403l5.062-12.16  C125.91,79.203,121.942,76.096,119.78,73.778z M90.75,64c0,14.773-11.977,26.75-26.75,26.75S37.25,78.773,37.25,64  S49.227,37.25,64,37.25S90.75,49.227,90.75,64z"
        />
      </svg>
    </div>
    <p class="half-margin">Settings</p>
  </div>

  <div class="flex">
    <div class="icon">
      <svg
        class="multiline-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 12"
      >
        <path
          stroke-linecap="round"
          stroke-width="2"
          d="M2 4h8M2 1h8M2 7h8m-8 3h3.5"
        />
      </svg>
    </div>
    <p class="half-margin">Create Multiline Command</p>
  </div>

  <div class="flex">
    <div class="icon">
      <svg
        class="alias-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          d="M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
        />
      </svg>
    </div>
    <p class="half-margin">Create Alias</p>
  </div>

  <div class="flex">
    <div class="icon">
      <svg
        class="about-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 365.442 365.442"
      >
        <path
          d="M212.994,274.074h-68.522c-3.042,0-5.708,1.149-7.992,3.429c-2.286,2.286-3.427,4.948-3.427,7.994v68.525
			c0,3.046,1.145,5.712,3.427,7.994c2.284,2.279,4.947,3.426,7.992,3.426h68.522c3.042,0,5.715-1.144,7.99-3.426
			c2.29-2.282,3.433-4.948,3.433-7.994v-68.525c0-3.046-1.14-5.708-3.433-7.994C218.709,275.217,216.036,274.074,212.994,274.074z"
        />
        <path
          d="M302.935,68.951c-7.806-14.378-17.891-26.506-30.266-36.406c-12.367-9.896-26.271-17.799-41.685-23.697
			C215.567,2.952,200.246,0,185.016,0C127.157,0,83,25.315,52.544,75.946c-1.521,2.473-2.046,5.137-1.571,7.993
			c0.478,2.852,1.953,5.232,4.427,7.135l46.824,35.691c2.474,1.52,4.854,2.281,7.139,2.281c3.427,0,6.375-1.525,8.852-4.57
			c13.702-17.128,23.887-28.072,30.548-32.833c8.186-5.518,18.461-8.276,30.833-8.276c11.61,0,21.838,3.046,30.692,9.132
			c8.85,6.092,13.271,13.135,13.271,21.129c0,8.942-2.375,16.178-7.135,21.698c-4.757,5.518-12.754,10.845-23.986,15.986
			c-14.842,6.661-28.457,16.988-40.823,30.978c-12.375,13.991-18.558,28.885-18.558,44.682v12.847c0,3.62,0.994,7.187,2.996,10.708
			c2,3.524,4.425,5.283,7.282,5.283h68.521c3.046,0,5.708-1.472,7.994-4.432c2.279-2.942,3.426-6.036,3.426-9.267
			c0-4.757,2.617-11.14,7.847-19.13c5.235-7.994,11.752-14.186,19.562-18.565c7.419-4.186,13.219-7.56,17.411-10.133
			c4.196-2.566,9.664-6.715,16.423-12.421c6.756-5.712,11.991-11.375,15.698-16.988c3.713-5.614,7.046-12.896,9.996-21.844
			c2.956-8.945,4.428-18.558,4.428-28.835C314.639,98.397,310.734,83.314,302.935,68.951z"
        />
      </svg>
    </div>
    <p class="half-margin">About</p>
  </div>

  <p>For more info, hover over anything and a tooltip will appear.</p>

  <p></p>
  <p>
    Suggestions, criticisms, bugs... compliments?<br />
    Any feedback is greatly appreciated!<br />
  </p>
  <p>
    You can direct message the creator through this discord server:<br />
    <a href="https://discord.gg/JeDmaRW2">https://discord.gg/JeDmaRW2</a>
  </p>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
